import type { FC } from 'react';

export const ErrorIcon: FC<{
  color?: string;
}> = (props) => (
  <svg width="100%" height="100%" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_285_1791)">
      <path
        d="M5 6.66667H4.99583M5 5.41667V3.33333M1.25 5C1.25 2.92892 2.92892 1.25 5 1.25C7.07107 1.25 8.75 2.92892 8.75 5C8.75 7.07107 7.07107 8.75 5 8.75C2.92892 8.75 1.25 7.07107 1.25 5Z"
        stroke={props.color || '#E6E6E9'}
        stroke-width="0.833333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_285_1791">
        <rect width="10" height="10" fill="white" transform="matrix(-1 0 0 -1 10 10)" />
      </clipPath>
    </defs>
  </svg>
);
